import ResortLandingPage from "@/components/ResortLandingPage";

const ExclusiveGavResorts = () => {
  return (
    <ResortLandingPage
      developmentSlug="exclusive-gav-resorts"
      title="Exclusive GAV Resorts"
      subtitle="Resort de alto padrao em Salinopolis, com foco em lazer, conforto e experiencias para toda a familia."
      cityState="Salinopolis/PA"
      description="O Exclusive GAV Resorts combina design contemporaneo, estrutura completa de lazer e localizacao privilegiada na regiao do Atalaia. O empreendimento oferece hospedagem ampla, gastronomia e opcoes de entretenimento para diferentes perfis de viagem."
      bannerPath="/empreendimentos/exclusive-gav-banner.png"
      galleryPaths={[
        "/empreendimentos/exclusive-gav-banner.png",
        "/empreendimentos/exclusive-gav-galeria-1.jpg",
        "/empreendimentos/exclusive-gav-galeria-2.png",
      ]}
      address="Rodovia PA-444, Estrada do Atalaia"
      bookingPhone="0800 300 6565"
      whatsapp="(62) 3773-9600"
      email="reservas@gfphoteis.com.br"
    />
  );
};

export default ExclusiveGavResorts;
